module.exports = __webpack_public_path__ + "img/reign-of-serenity.dda37639.webp";